module.exports = __webpack_public_path__ + "assets/img-coupon-bg-500-x-500.a43fe0d9.svg";